import { config } from "./config";

const queue = [];
export function track(event, props = {}) {
  if (!config.analytics.enabled) return;
  const safe = Object.fromEntries(Object.entries(props).filter(([k]) => !/name|email|message|phone/i.test(k)));
  queue.push({ event, props: safe, at: Date.now() });
}
